/* eslint-disable no-underscore-dangle */
import { jwtDecode } from 'jwt-decode';
import {
  setBaseURL,
  apiClient,
  setAuthorization,
} from '@/apis';
import { coreApiUrl } from '@/config';
import useUserStore from '@/stores/user';
import useDataStore from '@/stores/data';
import router from '@/router';
import apiErrorMessage from '@/utils/apiErrorMessage';

export const config = {};

const getScreenValue = (item) => {
  try {
    const data = JSON.parse(item);

    return data.type;
  } catch {
    return item;
  }
};

export const enabledCanvasSchema = [];

export default async ({ nonce, organizationId }) => {
  try {
    setBaseURL({ url: coreApiUrl });
    const response = await apiClient.post('/accounts/token');
    const { accessToken, idToken } = response;

    if (!accessToken) {
      throw new Error('Sorry, your token expired');
    }

    // check orgId
    const payload = jwtDecode(accessToken);

    if (payload.organization_id !== organizationId) {
      return;
    }

    sessionStorage.setItem('accessToken', accessToken);
    sessionStorage.setItem('idToken', idToken);
    const userStore = useUserStore();

    userStore.setUser({ accessToken });
    setAuthorization({ authorization: accessToken });

    const res = await apiClient.get('/canvas/get-info', {
      params: {
        nonce,
      },
    });

    const temp = res.context?.environment?.parameters?.notificationSetting || '{}';
    const tempFields = res.context?.environment?.parameters?.fields || '{}';
    const tempScreen = res.context.environment.parameters.screen || '{}';
    const settings = JSON.parse(temp);
    const fields = JSON.parse(tempFields);
    const screen = getScreenValue(tempScreen);
    config.ntfc__Status__c = settings.ntfc__Status__c;
    config.itmsg__Status__c = settings.itmsg__Status__c;

    Object.entries(res).forEach(([key, value]) => {
      config[key] = value;
    });

    const { setActivityData, setDataExtensions } = useDataStore();
    const schema = [];

    if (Array.isArray(fields)) {
      fields.forEach((key) => {
        schema.push({
          type: 'Text',
          key,
          name: key,
        });
      });
    } else {
      Object.entries(fields).forEach(([key]) => {
        schema.push({
          type: 'Text',
          key,
          name: key,
        });
      });
    }

    schema.forEach(({ name }) => {
      enabledCanvasSchema.push(name);
    });

    const temporaryDataExtension = {};

    schema.forEach((item) => {
      temporaryDataExtension[item.key] = item.key;
    });

    config.temporaryDataExtension = temporaryDataExtension;
    config.templateId = settings.itmsg__Sequence__c;
    setDataExtensions(schema);

    // 신규
    if (!settings.itmsg__Sequence__c) {
      setActivityData({});
      return;
    }

    // review
    if (screen === 'review') {
      await router.isReady();
      router.push({
        path: '/details',
        query: router.currentRoute._value.query,
      });
      return;
    }

    // result
    if (screen === 'rslt') {
      await router.isReady();
      router.push({
        path: '/result',
        query: router.currentRoute._value.query,
      });
      return;
    }

    let templateData = {};

    try {
      templateData = await apiClient.get(`/template/${settings.itmsg__Sequence__c}`);
    } catch (error) {
      apiErrorMessage(error, '메시지 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.');
      throw new Error('message not found');
    }

    const {
      activityBasic: {
        messageGroupVersionId: lastMessageGroupVersionId,
      },
      versionId,
      template: {
        rejectPhone,
        outgoingPhone,
        adult,
        departmentId: department,
        advert = {},
        failback = {},
        kakaoProfile,
        messageType,
        recipientNumberField: recipientNumber,
        redelivery,
        additionalFields,
        // reserve,
        preTemplateId,
        personalizedField: personalizationFields,
        encryptType,
        target: targetingSettings,
      },
    } = templateData;

    const initData = {
      templateId: settings.itmsg__Sequence__c,
      outgoingPhone,
      rejectPhone,
      recipientNumber,
      department,
      messageType,
      isAdvert: advert?.enabled,
      redeliveryEnabled: redelivery?.enabled,
      additionalFields,
      lastMessageGroupVersionId,
      // reserve,
      fallback: failback,
      kakaoProfile,
      adult,
      data: templateData.template,
      versionId,
      preTemplateId,
      personalizationFields,
      encryptType,
      targetingSettings,
    };

    setActivityData(initData);

    // // set activity data page
    // const event = new CustomEvent('set-activity-data', { detail: initData });
    // window.dispatchEvent(event);

    config.lastMessageGroupVersionId = lastMessageGroupVersionId;
  } catch (error) {
    console.error(error);
    Promise.reject(new Error('Sorry, your token expired'));
  }
};
